import React, { Fragment } from "react";
import HomeButton from "../../component/HomeButton";
import Button from "../../component/Button";
import { connect } from "react-redux";

import { getAllApartments, setPrinted } from "../../reducers/apartments";
import { logout, login } from "../../reducers/account";
import { getAllServices } from "../../reducers/services";

import { printOrder, printChecklist } from "../../services/createPdf";
import moment from "moment";

const loop = function timeout(action) {
  setTimeout(function () {
    action();
    timeout(action);
  }, 60000);
};

const startloop = (action) => {
  action();
  loop(action);
};

class Home extends React.Component {
  async componentDidMount() {
    if (!this.props.user) {
      this.props.login();
    }
    this.props.getAllServices();
    startloop(this.props.getAllApartments);
  }

  componentDidUpdate(oldProps) {
    if (oldProps.user !== this.props.user && !this.props.user) {
      this.props.history.push("/");
    }
    if (oldProps.errorUser !== this.props.errorUser && !this.props.user) {
      this.props.history.push("/");
    }
    if (
      oldProps.loadingUser !== this.props.loadingUser &&
      !this.props.loadingUser &&
      !this.props.user
    ) {
      this.props.history.push("/");
    }
  }

  showNotification = (apartmentName) => {
    const { apartments } = this.props;
    const apartment = apartments.find(
      (apartment) => apartment.name.toLowerCase() == apartmentName.toLowerCase()
    );

    if (!!apartment && !!apartment.user && !!apartment.user.userId) {
      const localStorageKeyName = apartment.name + "chat";
      const localStorageKey = localStorage.getItem(localStorageKeyName);
      if (localStorageKey) {
        return apartment.user.messaggi
          .filter((messaggio) => new Date(localStorageKey) - new Date(messaggio.createdAt) < 0)
          .filter((messaggi) => messaggi.from === "user").length;
      } else {
        localStorage.setItem(localStorageKeyName, new Date().toISOString());
      }
    }
    return 0;
  };

  showWarning = (apartmentName) => {
    const { apartments, services } = this.props;
    const apartment = apartments.find((apartment) => apartment.name == apartmentName);

    if (apartment && services.length > 0) {
      const localStorageKeys = this.props.services.map((ser) => {
        // const localStorageKeyName = apartment.name + ser.name;
        const localStorageKeyName = apartment.name + ser.target;
        const localStorageKey = localStorage.getItem(localStorageKeyName);
        let val;
        if (localStorageKey) {
          val = localStorageKey;
        } else {
          const now = new Date().toISOString();
          localStorage.setItem(localStorageKeyName, now);
          val = now;
        }
        return {
          // serviceName: ser.name,
          serviceName: ser.target,
          val,
        };
      });

      const warnings = localStorageKeys.map((obj) => {
        return apartment.user.servizi
          .filter((ser) => ser.tipologia.toLowerCase() === obj.serviceName.toLowerCase())
          .filter((ser) => new Date(obj.val) - new Date(ser.createdAt) < 0).length;
      });

      if (apartment.name === "Apt 010") {
        // console.log("warn", warnings);
        // console.log("warn", !!warnings.reduce((acc, curr) => acc + curr, 0));
      }

      return warnings.reduce((acc, curr) => acc + curr, 0);
    }
    return false;
  };

  logout = () => {
    this.props.logout();
  };

  formatDate = (date, toSort) => moment(date).format(toSort ? "YYYY/MM/DD" : "DD/MM/YYYY");

  formatHour = (date) => moment(date).format("HH:mm");

  getServiceDate = (ser, toSort) => {
    return this.formatDate(
      ser.data && ser.data.length > 0
        ? ser.data[0].data_prenotazione ||
            ser.data[0].data_consegna_prevista ||
            ser.data[0].orario ||
            ser.createdAt
        : ser.createdAt,
      toSort
    );
  };

  getHourRange = (data, durata) =>
    `${this.formatHour(data)} ${
      durata ? "- " + this.formatHour(moment(data).add(durata, "minutes")) : ""
    }`;

  getServiceHour = (ser) => {
    console.log("ser", ser);
    return ser.data && ser.data.length > 0
      ? !!ser.data[0].ora_consegna_prevista
        ? ser.data[0].ora_consegna_prevista
        : !!ser.data[0].orario || !!ser.data[0].data_prenotazione
        ? this.getHourRange(ser.data[0].orario || ser.data[0].data_prenotazione, ser.data[0].durata)
        : ""
      : "";
  };

  renderCode = (ser, apartment) => {
    return `${apartment.split(" ").reverse()[0]}${ser.tipologia.slice(0, 2).toUpperCase()}${
      ser.id
    }`;
  };

  renderRepetition = (type) => {
    switch (type) {
      case "mai":
        return "Singola";
      case "ogni_giorno":
        return "Giornaliera";
      case "ogni_settimana":
        return "Settimanale";
      case "ogni_due_settimane":
        return "Ogni due settimane";
      case "ogni_mese":
        return "Mensile";
      default:
        return "Singola";
    }
  };

  getServiceDescription = (obj) => {
    let cleaned = [...obj.data];
    if (obj.data.find((o) => !!o.tipologia || !!o.numero_pacco || o.ripetizione)) {
      cleaned = cleaned.map((ser) => {
        const s = {};

        if (!!ser.numero) {
          s.numero = ser.numero + "x";
        }
        if (!!ser.tipologia) {
          s.tipologia = ser.tipologia;
        }
        if (!!ser.mittente) {
          s.mittente = ser.mittente;
        }
        if (!!ser.numero_pacco) {
          s.numero_pacco = ser.numero_pacco;
        }
        if (!!ser.ripetizione) {
          s.ripetizione = this.renderRepetition(ser.ripetizione) + ",";
        }
        if (!!ser.giorno_ripetizione) {
          s.giorno_ripetizione = ser.giorno_ripetizione + " alle";
        }
        if (!!ser.ora_ripetizione) {
          s.ora_ripetizione = ser.ora_ripetizione;
        }
        if (!!ser.descrizione) {
          s.descrizione = ser.descrizione;
        }
        return s;
      });
    } else {
      return "1x " + obj.tipologia;
    }
    return cleaned.reduce((acc, curr, i) => {
      const arr = Object.entries(curr);
      return acc + arr.map((arr) => arr[1]).join(" ") + (i === cleaned.length - 1 ? "" : ", ");
    }, "");
  };

  resetNotification = async (printConfig) => {
    const orders = this.props.apartments
      .map((ap) => {
        return ap.user.servizi
          .filter((ser) => !ser.evaso)
          .filter((ser) => !ser.printed)
          .filter(
            (ser) =>
              this.getServiceDate(ser, true) >= this.formatDate(printConfig.from, true) &&
              this.getServiceDate(ser, true) <= this.formatDate(printConfig.to, true)
          )
          .map((ser) => {
            return {
              ...ser,
              apartment: ap.name,
              code: this.renderCode(ser, ap.name),
              dateToPrint: this.getServiceDate(ser, false),
              hourToPrint: this.getServiceHour(ser),
              descrizione: this.getServiceDescription(ser),
            };
          });
      })
      .flat()
      .sort((a, b) => {
        if (a.tipologia === b.tipologia) {
          return this.getServiceDate(a, true) > this.getServiceDate(b, true) ? 1 : -1;
        }
        return a.tipologia > b.tipologia ? 1 : -1;
      });

    console.log("orders", orders);
    if (orders.length > 0) {
      printChecklist(orders, printConfig);
      await Promise.all(
        orders.map(async (o) => {
          return await this.props.setPrinted(o.id);
        })
      );
    }
  };

  render() {
    // console.log(this.props.services)
    console.log(this.props.apartments);

    return (
      <Fragment>
        <div
          style={{
            display: "flex",
            width: window.innerWidth,
            height: window.innerHeight,
          }}
        >
          {/*<div>ciao</div>*/}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              padding: "6vh 1vh",
              justifyContent: "center",
              alignItems: "flex-start",
            }}
          >
            <HomeButton
              {...this.props}
              checklist={true}
              mainChecklist={true}
              apartmentName={"Stampa Checklist"}
              backgroundColor={"#91855D"}
              size={32}
              warning={0}
              notification={0}
              text={"#FFE533"}
              onClick={this.resetNotification}
            />
            {this.props.apartments.map((apartment, index) => {
              const warning = this.showWarning(apartment.name);
              const notification = this.showNotification(apartment.name);
              return (
                <HomeButton
                  key={`apt_${apartment.name}_${index}`}
                  {...this.props}
                  apartmentName={apartment.name}
                  backgroundColor="#FFE533"
                  size={32}
                  warning={warning}
                  notification={notification}
                  text="#645B40"
                  apartmentData={apartment}
                />
              );
            })}
          </div>
          <div style={{ paddingTop: "6vh", marginRight: "3vw" }}>
            <Button {...this.props} scope={"logOut"} goTo={this.logout} />
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  apartments: state.apartments.data,
  loading: state.apartments.loading,
  error: state.apartments.error,
  user: state.account.data.user,
  loadingUser: state.account.loading,
  errorUser: state.account.error,
  services: [...extraServices, ...state.services.data],
});

export default connect(mapStateToProps, {
  getAllApartments,
  logout,
  login,
  getAllServices,
  setPrinted,
})(Home);

const extraServices = [
  {
    name: "Bilancio",
    target: "bilancio",
  },
  {
    name: "Chat",
    target: "chat",
  },
];

// filtro su lastPrinted
// const lsLastPrinted = localStorage.getItem(
//   ap.name.replaceAll(" ", "").toLowerCase() +
//     "-" +
//     ser.tipologia.toLowerCase() +
//     "-" +
//     "print_time"
// );
// let lastPrinted;
// if (lsLastPrinted) {
//   lastPrinted = new Date(lsLastPrinted);
// } else {
//   lastPrinted = new Date("2021-01-01");
// }
// return new Date(ser.createdAt) > lastPrinted;
// const now = new Date();
//   this.props.apartments.map((apt) => {
//     this.props.services.map((service) => {
//       localStorage.setItem(apt.name + service.name, now.toISOString());
//       localStorage.setItem(
//         apt.name.replaceAll(" ", "").toLowerCase() +
//           "-" +
//           service.name.toLowerCase() +
//           "-" +
//           "print_time",
//         now.toISOString()
//       );
//     });
//   });
